import React from "react";
// import "./TipoImgsPregunta.css";

const TipoImgsPregunta = ({ pregunta, onResponder, className = "" }) => {
  return (
    <>
      {pregunta.imagenPregunta && Array.isArray(pregunta.imagenPregunta) && (
        <div className="imagenes-comparacion">
          {pregunta.imagenPregunta.map((imagen, index) => (
            <div key={index} className="imagen-item">
              <img
                src={imagen.src}
                alt={`Imagen ${index + 1}`}
                className="imagen-comparacion"
              />
            </div>
          ))}
        </div>
      )}

      <p
        className={`pregunta-texto ${className}`}
        style={{
          marginBottom: "40px",
        }}
      >
        {pregunta.pregunta}
      </p>

      <div className={`botones-ojo ${className}`}>
        {pregunta.opciones.map((opcion, index) => (
          <button
            key={index}
            className={`btn-ojo ${className}`}
            onClick={() => onResponder(index)}
          >
            {opcion.text}
          </button>
        ))}
      </div>
    </>
  );
};

export default TipoImgsPregunta;